/* ======================================================================
   "Recipes" Navigation Menu Item
   Injects a dropdown into the header nav (desktop + mobile drawer + sticky
   clone). Labelled "Recipes" to match the Figma header; the linked pages are
   still the per-mix cooking-instruction pages.

   Filename kept as cooking-instructions-nav.js so the asset_url reference in
   layout/theme.liquid and the uploaded asset stay valid.
   ====================================================================== */
(function addCookingInstructionsNav() {
  document.addEventListener('DOMContentLoaded', () => {
    // Function to add menu item to a specific navigation
    function addToNav(navSelector, navType) {
      const nav = document.querySelector(navSelector);

      if (!nav) return false;

      // Check if already added to this nav
      const existingId = `menu-item-recipes-${navType}`;
      if (document.getElementById(existingId)) return true;

      // Find the "Contact" menu item
      const menuItems = Array.from(nav.children);
      const contactIndex = menuItems.findIndex(li => {
        const link = li.querySelector('a');
        return link && link.textContent.trim().toLowerCase().includes('contact');
      });

      if (contactIndex === -1) return false; // Contact not found

      // Create cooking instructions menu item
      const cookingMenuItem = document.createElement('li');
      cookingMenuItem.id = existingId;
      cookingMenuItem.className = 'has-submenu';
      cookingMenuItem.setAttribute('aria-controls', `SiteNavLabel-recipes-${navType}`);
      cookingMenuItem.setAttribute('aria-expanded', 'false');

      // NB the two chevrons below are hand-copied from snippets/theme-symbols.liquid
      // because this is JS and cannot render a Liquid snippet. Keep them in sync —
      // in particular the viewBox: without it the artwork has no user-coordinate
      // mapping, so tlh-header.css sizing the caret to 11x6 CROPS a 13x8 drawing
      // instead of scaling it.

      // Add submenu-back button for mobile/sidebar navigation
      const submenuBack = navType === 'sidebar' ? `
        <li class="submenu-back">
          <a><span class="icon">
            <svg width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.414.086 7.9 6.57 6.485 7.985 0 1.5 1.414.086Z" fill="#7e4a0e"/><path d="M12.985 1.515 6.5 8 5.085 6.586 11.571.101l1.414 1.414Z" fill="#7e4a0e"/></svg>
          </span>Back</a>
        </li>
      ` : '';

      // Relative URLs so the links resolve against whatever host is being viewed.
      // They previously pointed at https://thelentilhub.com/... with target="_blank",
      // which meant every dropdown item jumped from the dev/preview theme to the
      // LIVE site in a new tab.
      const RECIPE_PAGES = [
        ['Sunny Toor Mix', '/pages/st'],
        ['Mung Mix',       '/pages/mm'],
        ['Trinity Mix',    '/pages/tm'],
        ['Meadow Mix',     '/pages/meadow'],
        ['Yogi Mix',       '/pages/ym'],
        ['Sundown Mix',    '/pages/sd'],
        ['Vida Mix',       '/pages/vm']
      ];

      const recipeItems = RECIPE_PAGES.map(([label, href]) => `
            <li>
              <a title="${label}" class="menu-link no-focus-link" href="${href}">
                <span><span class="text-animation--underline-in-header">${label}</span></span>
              </a>
            </li>`).join('');

      // The parent carries no href on purpose. It used to point at
      // /blogs/recipes, which 404s — that blog was never created, and there is
      // no recipe index to send it to; the seven pages below ARE the recipes.
      // So it is a disclosure only, the way .submenu-back above is, and the
      // dropdown is what does the navigating.
      cookingMenuItem.innerHTML = `
        <a title="Recipes" class="menu-link">
          <span><span class="text-animation--underline-in-header">Recipes</span></span>
          <span class="icon">
            <svg width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.414.086 7.9 6.57 6.485 7.985 0 1.5 1.414.086Z" fill="#7e4a0e"/><path d="M12.985 1.515 6.5 8 5.085 6.586 11.571.101l1.414 1.414Z" fill="#7e4a0e"/></svg>
          </span>
        </a>

        <ul class="submenu normal-menu" id="SiteNavLabel-recipes-${navType}">
          <div class="submenu-holder">
            ${submenuBack}${recipeItems}
          </div>
        </ul>
      `;

      // Insert before Contact menu item
      nav.insertBefore(cookingMenuItem, menuItems[contactIndex]);

      // Initialize dropdown functionality (matching section-header.js behavior)
      const menuLink = cookingMenuItem.querySelector('.menu-link');

      // NOTE: there used to be a `mouseover` handler here that set
      //   submenu.style.left = cookingMenuItem.getBoundingClientRect().left + 'px'
      // i.e. it wrote the item's VIEWPORT x into an inline `left`. That only ever
      // lined up while the submenu's offsetParent happened to start at x=0 and the
      // nav was left-aligned. With the nav centred — and now that the <li> is a
      // positioning context — it pushed the panel a further ~780px to the right.
      // Positioning is handled purely in CSS now (li{position:relative} + left:0),
      // so the inline style must NOT be reintroduced: it would override the CSS.

      // Mobile/Sidebar navigation click handler
      if (navType === 'sidebar') {
        const mobileNav = cookingMenuItem.closest('mobile-navigation');

        menuLink.addEventListener('click', function(e) {
          e.preventDefault();

          // Access the mobile navigation element's internal state
          if (!mobileNav._openedFirstSubmenu) {
            mobileNav._openedFirstSubmenu = true;
            mobileNav.classList.add('opened-first-submenu');
            const sidebarDrawer = mobileNav.closest('sidebar-drawer');
            if (sidebarDrawer) {
              sidebarDrawer.scrollTo({top: 0});
            }
          }

          cookingMenuItem.classList.add('opened');

          // Resize container
          if (mobileNav._openedSecondSubmenu) {
            mobileNav.style.height = `${mobileNav.querySelector('.has-babymenu.opened .babymenu').scrollHeight}px`;
          } else if (mobileNav._openedFirstSubmenu) {
            mobileNav.style.height = `${mobileNav.querySelector('.has-submenu.opened .submenu').scrollHeight}px`;
          }
        });

        // Handle back button click
        const backButton = cookingMenuItem.querySelector('.submenu-back a');
        if (backButton) {
          backButton.addEventListener('click', function(e) {
            e.preventDefault();

            if (mobileNav._openedSecondSubmenu) {
              mobileNav._openedSecondSubmenu = false;
              mobileNav.classList.remove('opened-second-submenu');
            } else if (mobileNav._openedFirstSubmenu) {
              mobileNav._openedFirstSubmenu = false;
              mobileNav.classList.remove('opened-first-submenu');
              mobileNav.style.height = 'auto';
            }

            const sidebarDrawer = mobileNav.closest('sidebar-drawer');
            if (sidebarDrawer) {
              sidebarDrawer.scrollTo({top: 0});
            }

            setTimeout(() => {
              cookingMenuItem.classList.remove('opened');
            }, 301);
          });
        }
      }

      // Touch navigation for desktop (from section-header.js lines 234-245)
      if (navType === 'classic') {
        cookingMenuItem.addEventListener('touchstart', function() {
          menuLink.style.pointerEvents = 'none';
          cookingMenuItem.classList.toggle('focus');

          // Close other open submenus
          document.querySelectorAll('.style--classic li.focus').forEach(function(elm) {
            if (elm !== cookingMenuItem) {
              elm.classList.remove('focus');
            }
          });
        });
      }

      // Keyboard navigation (from section-header.js lines 249-278)
      cookingMenuItem.addEventListener('keydown', function(e) {
        var KEYCODES = { RETURN: 13, ESC: 27, TAB: 9 };

        if (e.keyCode === KEYCODES.RETURN) {
          if (!e.target.classList.contains('no-focus-link')) {
            e.preventDefault();
          }
          if (!cookingMenuItem.classList.contains('focus')) {
            cookingMenuItem.classList.add('focus');
            cookingMenuItem.setAttribute('aria-expanded', 'true');
          } else if (document.activeElement.parentNode.classList.contains('has-submenu') && cookingMenuItem.classList.contains('focus')) {
            cookingMenuItem.classList.remove('focus');
            cookingMenuItem.setAttribute('aria-expanded', 'false');
          }
        }
      });

      // Focus out on last item to close dropdown
      var lastLink = cookingMenuItem.querySelector('.submenu-holder > li:last-child a');
      if (lastLink) {
        lastLink.addEventListener('focusout', function() {
          if (cookingMenuItem.classList.contains('focus')) {
            cookingMenuItem.classList.remove('focus');
            cookingMenuItem.setAttribute('aria-expanded', 'false');
          }
        });
      }

      return true;
    }

    // Try to add to desktop nav, mobile drawer, and the sticky-header clone.
    //
    // section-header.js builds the sticky bar by cloning .header__bottom at mount,
    // which happens BEFORE this injection runs — so the sticky nav was permanently
    // missing this item (4 links instead of 5). Injecting into the clone too keeps
    // the sticky bar in sync with the real header.
    const checkNav = setInterval(() => {
      const classicAdded = addToNav('main-header .site-nav.style--classic nav ul.link-list', 'classic');
      const sidebarAdded = addToNav('.site-nav.style--sidebar nav ul.link-list', 'sidebar');

      // Opportunistic: the clone only exists when the sticky header is enabled,
      // so it must never gate clearInterval.
      addToNav('.sticky-header .site-nav.style--classic nav ul.link-list', 'sticky');

      // Stop checking once the two required navs are in place
      if (classicAdded && sidebarAdded) {
        clearInterval(checkNav);
      }
    }, 100);

    // Stop checking after 10 seconds
    setTimeout(() => clearInterval(checkNav), 10000);
  });
})();
